/**
 * Country-region sub module
 */
module.exports = {

    /**
     * initialize
     */
    init: function (params) {
        // The regions object
        var regionsMap = params.regionsMap;
        var $contactAddress = $(params.regionField);
        var $country = $('#address\\.country');

        // Change the regions using this country code
        function changeRegion(countryCode) {

            var $inputbox = $('input#address\\.contactAddress4.js-zainput');

            if (countryCode === 'ZA') {
                $inputbox.prop('readonly', false);

                var sa = false;
                $.each(regionsMap, function (i, map) {
                    $.each(map, function (j, region) {
                        if (region.name === $inputbox.val()) {
                            sa = true;
                            return false;
                        }
                    });
                });
                if (sa) {
                    $inputbox.val('');
                    return false;
                }


            } else {
                $inputbox.prop('readonly', true);
                $contactAddress.empty();

                $.each(regionsMap[countryCode], function (i, region) {
                    if (region.code !== '0') {
                        $inputbox.val(region.name);
                        $contactAddress.val(region.name);
                    }
                });
            }
        }

        // Populate the region drop down with the current country
        changeRegion($country.val());

        // When the country changes then update the regions by attaching a change listener to the country drop down
        $country.change(function () {
            changeRegion(this.value);
        });

    }
};



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/registration/countryRegionZA.js
// module id = 256
// module chunks = 4